import { createContext } from 'react';

const SiteCountryContext = createContext('EN');

export default SiteCountryContext;
